module.exports = __webpack_public_path__ + "static/media/5i_website_logo_diamond_tencent.6134a72d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5i_website_logo_diamond_tencent.jpg
// module id = 93
// module chunks = 0